/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_Field_Occupation_WordsInputs */

const en_us2_search_field_occupation_words = /** @type {(inputs: Search_Field_Occupation_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`work occupation job`)
};

const pt_br2_search_field_occupation_words = /** @type {(inputs: Search_Field_Occupation_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`trabalho ocupacao emprego`)
};

const es_419_search_field_occupation_words = /** @type {(inputs: Search_Field_Occupation_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`trabajo ocupacion empleo`)
};

const pt_pt2_search_field_occupation_words = /** @type {(inputs: Search_Field_Occupation_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`trabalho ocupacao emprego profissao`)
};

const fr_fr2_search_field_occupation_words = /** @type {(inputs: Search_Field_Occupation_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`travail metier emploi profession`)
};

const de_de2_search_field_occupation_words = /** @type {(inputs: Search_Field_Occupation_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`arbeit beruf job`)
};

const it_it2_search_field_occupation_words = /** @type {(inputs: Search_Field_Occupation_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`lavoro occupazione impiego`)
};

/**
* | output |
* | --- |
* | "work occupation job" |
*
* @param {Search_Field_Occupation_WordsInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const search_field_occupation_words = /** @type {((inputs?: Search_Field_Occupation_WordsInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Field_Occupation_WordsInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_search_field_occupation_words(inputs)
	if (locale === "es-419") return es_419_search_field_occupation_words(inputs)
	if (locale === "pt-PT") return pt_pt2_search_field_occupation_words(inputs)
	if (locale === "fr-FR") return fr_fr2_search_field_occupation_words(inputs)
	if (locale === "de-DE") return de_de2_search_field_occupation_words(inputs)
	if (locale === "it-IT") return it_it2_search_field_occupation_words(inputs)
	return en_us2_search_field_occupation_words(inputs)
});
export { search_field_occupation_words as "search.field_occupation_words" }